import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import FormButtons from '../../../core/form/FormButtons';
import LocalFileInput from '../../../core/form/LocalFileInput';
import FetchSelect from '../../../core/form/FetchSelect';
import Select from '../../../core/form/Select';

class VocabularyForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    values: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    submitting: PropTypes.bool,
    isDirty: PropTypes.func,
  };

  static defaultProps = {
    values: {},
    errors: {},
    submitting: false,
    isDirty: () => false,
    onSubmit: () => alert('submitted'),
    onReset: () => false,
    vocabularyThemes: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
      }).isRequired
    ),
  };

  render() {
    return (
      <form
        onSubmit={(event) => {
          event.preventDefault();
          this.props.onSubmit();
        }}
      >
        <Row>
          <Column size={4}>
            <Select
              required
              label="Vocabulary Theme"
              onChange={(value) => this.props.onChange('vocabularyTheme', value)}
              value={get(this.props.values, 'vocabularyTheme', '')}
              options={this.props.vocabularyThemes.map((vocabularyTheme) => ({
                label: vocabularyTheme.name,
                value: vocabularyTheme.id,
              }))}
            />
          </Column>
          <Column size={4}>
            <FetchSelect
              url="academic-plans"
              required
              disabled={this.props.submitting}
              label="Academic Plan"
              value={get(this.props.values, 'academicPlan', '')}
              onChange={(value) => this.props.onChange('academicPlan', value)}
              errorText={get(this.props.errors, 'academicPlan', '')}
              resultTransformer={{
                text: 'name',
                value: 'id',
              }}
            />
          </Column>
          <Column size={4}>
            <TextInput
              required
              disabled={this.props.submitting}
              label="Text"
              value={get(this.props.values, 'text', '')}
              onChange={(value) => this.props.onChange('text', value)}
              errorText={get(this.props.errors, 'text', null)}
            />
          </Column>
          <Column size={2}>
            <LocalFileInput
              required
              value={get(this.props.values, 'image', null)}
              onChange={(value) => this.props.onChange('image', value)}
              label="Select the image"
              accept="image"
              disabled={this.props.submitting}
              errorText={get(this.props.errors, 'image', null)}
            />
          </Column>
          <Column size={5}>
            <TextInput
              disabled={this.props.submitting}
              label="Sentence"
              required
              value={get(this.props.values, 'sentence', '')}
              onChange={(value) => this.props.onChange('sentence', value)}
              errorText={get(this.props.errors, 'sentence', null)}
            />
          </Column>
          <Column size={5}>
            <TextInput
              disabled={this.props.submitting}
              label="Translate"
              required
              value={get(this.props.values, 'translate', '')}
              onChange={(value) => this.props.onChange('translate', value)}
              errorText={get(this.props.errors, 'translate', null)}
            />
          </Column>
        </Row>
        <FormButtons
          confirmLabel={this.props.values.id ? 'Update Vocabulary' : 'Create Vocabulary'}
          isDisabled={this.props.submitting || !this.props.isDirty()}
          isSubmitting={this.props.submitting}
          onReset={this.props.onReset}
        />
      </form>
    );
  }
}

export default VocabularyForm;
